module.exports = __webpack_public_path__ + "img/04.f4557be1.jpg";